import styled from 'styled-components';
import { ADMIN_SCROLL_BAR, SCROLL_BAR } from 'style/mixins';

export interface StyleProps {
  admin: boolean;
  disableScroll: boolean;
  offset: number;
}

type Style<T extends keyof StyleProps> = Pick<StyleProps, T>;

export const ScrollContainer = styled.div<Style<'admin' | 'disableScroll'>>`
  ${({ admin }) => admin ? ADMIN_SCROLL_BAR : SCROLL_BAR};
  overflow: ${({ disableScroll }) => disableScroll ? 'hidden' : 'hidden auto'};
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const Observer = styled.div<Style<'offset'>>`
  visibility: hidden;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: ${({ offset }) => offset}px;
  margin: 0 !important;
  padding: 0 !important;
`;
